export const resolveTimeRemaining = (expiration: Date | null | undefined, now: Date): number | null => {
  if (!expiration) {
    return null;
  }

  return Math.max(0, expiration.getTime() - now.getTime());
};
